import React, { useState, useEffect } from 'react';

export default function InactivityWarning({ show, onStayLoggedIn, onLogout, remainingSeconds }) {
  const [seconds, setSeconds] = useState(remainingSeconds || 300);

  useEffect(() => {
    if (!show) {
      setSeconds(remainingSeconds || 300);
      return;
    }

    const timer = setInterval(() => {
      setSeconds(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [show, onLogout, remainingSeconds]);

  if (!show) return null;

  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;

  return React.createElement('div', {
    style: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }
  },
    React.createElement('div', {
      style: {
        background: 'white',
        borderRadius: 16,
        padding: 32,
        maxWidth: 400,
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }
    },
      React.createElement('div', {
        style: { fontSize: 48, marginBottom: 16 }
      }, '⏰'),
      React.createElement('h2', {
        style: { fontSize: 20, fontWeight: 700, color: '#1e293b', marginBottom: 8 }
      }, 'Αδράνεια'),
      React.createElement('p', {
        style: { fontSize: 14, color: '#64748b', marginBottom: 24 }
      }, 'Θα αποσυνδεθείτε αυτόματα λόγω αδράνειας.'),
      React.createElement('div', {
        style: {
          fontSize: 36,
          fontWeight: 700,
          color: '#dc2626',
          marginBottom: 24,
          fontFamily: 'monospace'
        }
      }, minutes + ':' + (secs < 10 ? '0' : '') + secs),
      React.createElement('div', {
        style: { display: 'flex', gap: 12, justifyContent: 'center' }
      },
        React.createElement('button', {
          onClick: onLogout,
          style: {
            padding: '12px 24px',
            borderRadius: 8,
            border: '1px solid #e2e8f0',
            background: 'white',
            color: '#64748b',
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer'
          }
        }, 'Αποσύνδεση'),
        React.createElement('button', {
          onClick: onStayLoggedIn,
          style: {
            padding: '12px 24px',
            borderRadius: 8,
            border: 'none',
            background: '#7c3aed',
            color: 'white',
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer'
          }
        }, 'Παραμονή')
      )
    )
  );
}
